import { message } from 'antd';
import { put, select, takeLatest } from 'redux-saga/effects';
import { RootState } from 'data';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  deleteSpaceInProjectTemplate,
  MinSpaceIdInProjectTemplatePayload,
} from '../../actions';
import { deleteProjectTemplateSpace } from '../../slices';
import { ProjectTemplateSpace } from '../../types';

const selectSpace =
  (id: number) =>
  ({ templates }: RootState): ProjectTemplateSpace =>
    templates.project.data[templates.project.activeId].spaceList[id];

function* deleteSpaceInTemplateSaga(
  action: StoreActionProps<MinSpaceIdInProjectTemplatePayload>,
) {
  try {
    const { payload } = action;

    const space: ProjectTemplateSpace = yield select(
      selectSpace(payload.space.spaceId),
    );

    yield put(deleteProjectTemplateSpace(space));
  } catch (error) {
    logger.error('deleteProjectTemplateSpace failed', { error });

    message.error('There was an error deleting the space from the template');
  }
}

export function* watchDeleteSpaceInProjectTemplateSaga(): Generator {
  yield takeLatest(
    deleteSpaceInProjectTemplate.type,
    deleteSpaceInTemplateSaga,
  );
}
